module.exports = __webpack_public_path__ + "static/media/undraw_Source_code_re_wd9m.1fc4b61f.svg";